import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStructuresMap = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "100%",
	height: "100%",
	viewBox: "0 0 417 417",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	xmlSpace: "preserve",
	"xmlns:serif": "http://www.serif.com/",
	style: {
		fillRule: "evenodd",
		clipRule: "evenodd",
		strokeLinejoin: "round",
		strokeMiterlimit: 2
	},
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			id: "background",
			x: 0,
			y: 0,
			width: 416.667,
			height: 416.667,
			style: { fill: "#979797" }
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M111.301,281.364c-17.749,-13.016 -39.642,-20.706 -63.318,-20.706l-0,-129.293c-0,-46.02 37.362,-83.382 83.382,-83.382l130.093,-0c0,23.47 7.557,45.189 20.369,62.855l-170.526,170.526Zm194.528,-146.524c17.665,12.811 39.385,20.368 62.855,20.368l-0,130.094c-0,46.019 -37.363,83.382 -83.382,83.382l-130.097,-0l0.003,-0.801c0,-23.265 -7.425,-44.809 -20.033,-62.389l170.654,-170.654Z",
			style: { fill: "#505050" }
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "extra",
			d: "M0,416.667l0,-416.667l182.311,0l0.005,-0.244l234.351,-0l-0,416.911l-416.667,-0Zm181.918,-396.747l-68.895,-0.061c-22.084,0.945 -40.42,6.203 -54.924,15.873c-14.272,9.275 -23.366,21.31 -29.031,35.175c-5.109,11.405 -8.539,24.743 -10.265,40.041l-0.515,128.323l0.027,-0l0,45.227l-7.182,7.182l-0,112.719l112.537,-0l7.829,-7.83l103.251,-0.144l-0.007,0.321l68.9,0.062c22.084,-0.945 40.421,-6.204 54.925,-15.874c13.601,-8.102 22.889,-20.186 29.031,-35.174c5.109,-11.405 8.538,-24.743 10.265,-40.042l0.516,-128.566l-0.029,-0l0,-45.227l7.183,-7.182l-0,-112.719l-112.537,-0l-7.829,7.829l-3.955,0.006l0,0.15l-65.712,-0.059l-33.584,0.047l0.001,-0.077Z",
			style: { fill: "#343434" }
		})
	]
});
export default SvgStructuresMap;
